import * as z from 'zod/v4';
import { EnumParams } from '../events.types';
import { MODES_REQUIRING_ELEMENT } from './combat-consts';

export const modesOpenSectionSchema = (enums?: EnumParams) =>
  z.object({
    modes: z.array(
      z
        .object({
          gameMode: enums ? z.enum(enums.GameMode) : z.string(),
          element: enums ? z.enum(enums.CombatTag).optional() : z.string().optional(),
        })
        .refine(
          row => {
            const requiresElement = (MODES_REQUIRING_ELEMENT as readonly string[]).includes(
              row.gameMode,
            );
            return requiresElement ? row.element !== undefined : row.element === undefined;
          },
          {
            message:
              'Element is required for DailyDungeon and GuildBoss, and must be absent for other modes',
          },
        ),
    ),
  });
